import React, { useReducer, useContext } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { api } from '../../../services/api'
import ColorButton from '../../Buttons/ColorButton';
import DefaultModal from '../../Utils/DefaultModal';
import toast from 'react-hot-toast'
import { Box, Tooltip, TextField } from '@mui/material'
import validateData from './validateData';
import { externalComponent } from '../../AppRoutes';
import MegaAutoComplete from '../../Utils/megautocomplete';

const url = '/informacao_li/'

const submit = async (data, getData, setLoader, handleClose) => {

    setLoader(true)
    let res = null

    if (data.id)
        res = await api.patch(`${url}${data.id}/`, data)
    else
        res = await api.post(url, data)
    if (res.status === 201 || res.status === 200) {
        toast.success(`Informação complementar LI ${res.status === 201 ? 'adicionado' : 'editado'} com sucesso`)
        getData()
        handleClose()
        setLoader(false)
        return
    }
    toast.error(`Informação complementar LI não pôde ser ${!data.id ? 'adicionado' : 'editado.'} Motivo: ${res.data}`)
    setLoader(false)
}

const getTitle = (data) => {
    if (data?.id)
        return 'Editar'
    return 'Adicionar'
}

const EditInformacaoLI = ({data, handleClose, reloadData}) => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        origin_contry: '',
        cod_country: '',
        additional_information: '',
        ...data,
        id: data.id ? data.id : 0
    })

    const validData = validateData(state)

    return(
        <>
        <DefaultModal
                title={
                    `${getTitle(state)} Informação complementar LI`
                }
                handleClose={handleClose}
                content={
                    <>
                        <Box className='item-content-modal noborder' >
                            <Box className='item-profile-row'>
                                <TextField
                                    id="cod_country"
                                    type="text"
                                    label="Cod. País"
                                    value={state.cod_country}
                                    onChange={(e) => { setState({ 'cod_country': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />

                            </Box>
                            <Box className='item-profile-row'>
                                <MegaAutoComplete
                                    value={state.origin_contry}
                                    onChange={(data) => setState({ origin_contry: data })}
                                    noOptionsText={'Digite para procurar um país'}
                                    timeoutUrl='/porto/countries/'
                                    timeoutParam='label'
                                    label='País de origem'
                                />
                            </Box>

                            <Box className='item-profile-row'>
                                <TextField
                                    id="additional_information"
                                    type="text"
                                    label="Informação complementar"
                                    value={state.additional_information}
                                    onChange={(e) => { setState({ 'additional_information': e.target.value }) }}
                                    fullWidth={false}
                                    size='small'
                                    multiline
                                    rows={4}
                                    inputProps={{
                                        maxLength: 255
                                    }}
                                />

                            </Box>
                        </Box>
                    </>
                }
                action={
                    <>
                        <Tooltip placement="left" title={validData}>
                            <Box>
                                <ColorButton
                                    onClick={() => submit(state, reloadData, setLoader, handleClose)}
                                    disabled={validData}
                                >Salvar
                                </ColorButton>
                            </Box>
                        </Tooltip>
                    </>
                }
            />
        </>
    )
}

export default EditInformacaoLI;